import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  CLEAR_LOGIN_ERROR,
  REFRESH_ACCESS_TOKEN_REQUEST,
  REFRESH_ACCESS_TOKEN_SUCCESS,
  REFRESH_ACCESS_TOKEN_FAILURE,
  CREATE_PASSWORD_REQUEST,
  CREATE_PASSWORD_SUCCESS,
  CREATE_PASSWORD_FAILURE,
  CLEAR_CREATE_PASSWORD_ERROR,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CLEAR_RESET_PASSWORD_ERROR,
} from "./authActionTypes";
import {
  setItem,
  clearItems,
} from "../../../components/utilities/UtilityFunctions";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import api from "../../api/api";

export const login = (credentials, navigate) => {
  return async (dispatch) => {
    try {
      const response = await api.post("/Accounts/authenticate", credentials);

      setItem("accessToken", response.data.accessToken);
      setItem("isLoggedIn", true);
      setItem("loggedInUserId", response.data.id);
      setItem("loggedInUserRoleId", response.data.roleId);
      setItem("loggedInUserFirstName", response.data.firstName);
      setItem("loggedInUserLastName", response.data.lastName);
      setItem("loggedInUserRole", response.data.roleName);
      setItem("loggedInUserMembershipId", response.data.membershipId);
      setItem("loggedInUserBusinessName", response.data.businessName);

      localStorage.setItem("userId", response.data.id);
      localStorage.setItem("firstName", response.data.firstName);
      localStorage.setItem("lastName", response.data.lastName);
      localStorage.setItem(
        "loggedInUserRolePermissions", 
        JSON.stringify(response.data.rolePermissions),
      );

      Cookies.set(
        "loggedInUserRolePermissions",
        JSON.stringify(response.data.rolePermissions),
        { expires: 7 },
      );

      dispatch({ type: LOGIN_SUCCESS, payload: response.data });
      toast.success("Logged in successfully");

      // Check if isGeneratePasswordChanged is false and redirect to ChangePasswordContent
      if (response.data.isGeneratePasswordChanged === false) {
        navigate("/changepassword");
      } else {
        navigate("/dashboard"); // Or the dashboard route after login
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          dispatch({
            type: LOGIN_FAILURE,
            payload:
              "We couldn't process your request. Please double-check the information you've provided and try again.",
          });
        } else if (error.response.status === 401) {
          dispatch({
            type: LOGIN_FAILURE,
            payload: "Seems like you entered an incorrect email or password",
          });
        } else if (error.response.status === 500) {
          dispatch({
            type: LOGIN_FAILURE,
            payload:
              "Oops! seems like our servers are having issues. Try again in a bit",
          });
        } else {
          dispatch({
            type: LOGIN_FAILURE,
            payload: "An unknown error occurred. Please try again soon",
          });
        }
      } else if (error.request) {
        dispatch({
          type: LOGIN_FAILURE,
          payload: "Our server didn't respond. Please try again in a bit",
        });
      } else {
        dispatch({
          type: LOGIN_FAILURE,
          payload: "The request had an error. Please try again later",
        });
      }
    }
  };
};

export const refreshAccessToken = () => {
  return async (dispatch) => {
    dispatch({ type: REFRESH_ACCESS_TOKEN_REQUEST });

    try {
      const response = await api.post(
        "/Accounts/refresh-token",
        {},
        { withCredentials: true },
      );

      if (response.data && response.data.accessToken) {
        const newAccessToken = response.data.accessToken;
        setItem("accessToken", newAccessToken);
        dispatch({
          type: REFRESH_ACCESS_TOKEN_SUCCESS,
          payload: newAccessToken,
        });
        return newAccessToken;
      } else {
        throw new Error("No access token found in response");
      }
    } catch (error) {
      dispatch({
        type: REFRESH_ACCESS_TOKEN_FAILURE,
        payload: "Failed to refresh token",
      });
      clearItems();
      toast.error("Session expired. Please log in again.");
      throw error;
    }
  };
};

export const clearLoginError = () => {
  return { type: CLEAR_LOGIN_ERROR };
};

export const logout = () => {
  return (dispatch) => {
    dispatch({ type: LOGOUT });
    clearItems();
    Cookies.remove("loggedInUserRolePermissions");
    toast.success("Logged out successfully");
  };
};

export const requestPasswordReset = (email) => {
  return async (dispatch) => {
    dispatch({ type: RESET_PASSWORD_REQUEST });

    try {
      const response = await api.post("/Accounts/forgot-password", { email });
      dispatch({ type: RESET_PASSWORD_SUCCESS, payload: response.data });
      toast.success("Password reset link sent successfully");
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          dispatch({
            type: RESET_PASSWORD_FAILURE,
            payload:
              "Hmm... we can't find that email address in our system. Double-check your typing or try another email address",
          });
        } else if (error.response.status === 500) {
          dispatch({
            type: RESET_PASSWORD_FAILURE,
            payload:
              "Oops! seems like our servers are having issues. We're on it! Try again in a bit",
          });
        } else {
          dispatch({
            type: RESET_PASSWORD_FAILURE,
            payload: "An unknown error occurred. Please try again soon",
          });
        }
      } else if (error.response) {
        dispatch({
          type: RESET_PASSWORD_FAILURE,
          payload: "Our server didn't respond. Please try again in a moment",
        });
      } else {
        dispatch({
          type: RESET_PASSWORD_FAILURE,
          payload: "The request had an error. Please try again later",
        });
      }
    }
  };
};



export const resetPassword = ({ token, password, confirmPassword }, navigate) => {
  return async (dispatch) => {
    dispatch({ type: RESET_PASSWORD_REQUEST });

    try {
      const response = await api.post(
        '/Accounts/reset-password',
        { token, password, confirmPassword },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
          },
        }
      );

      const userData = response.data;

      // Persist authentication data
      setItem("accessToken", userData.accessToken);
      setItem("isLoggedIn", true);
      setItem("loggedInUserId", userData.id);
      setItem("loggedInUserRoleId", userData.roleId);
      setItem("loggedInUserFirstName", userData.firstName);
      setItem("loggedInUserLastName", userData.lastName);
      setItem("loggedInUserRole", userData.roleName);
      setItem("loggedInUserMembershipId", userData.membershipId);

      localStorage.setItem("userId", userData.id);
      localStorage.setItem("firstName", userData.firstName);
      localStorage.setItem("lastName", userData.lastName);
      localStorage.setItem(
        "loggedInUserRolePermissions",
        JSON.stringify(userData.rolePermissions)
      );

      Cookies.set(
        "loggedInUserRolePermissions",
        JSON.stringify(userData.rolePermissions),
        { expires: 7 }
      );

      dispatch({ type: CREATE_PASSWORD_SUCCESS, payload: userData });

      // Automatically log the user in
      dispatch({ type: LOGIN_SUCCESS, payload: userData });

      toast.success('Password created successfully');
      toast.success('Logging you in...');

      // Navigate to dashboard
      navigate('/dashboard');

      return userData;
    } catch (error) {
      console.error('Create password error:', error);

      if (error.response) {
        if (error.response.status === 400) {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'Invalid request. Please check your password or try again.',
          });
          toast.error('Invalid request. Please check your password or try again.');
        } else if (error.response.status === 401) {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'Invalid or expired token. Please request a new create password link.',
          });
          toast.error('Invalid or expired token. Please request a new create password link.');
        } else if (error.response.status === 403) {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'You do not have permission to create password.',
          });
          toast.error('You do not have permission to create password.');
        } else if (error.response.status === 404) {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'Reset token not found.',
          });
          toast.error('Reset token not found.');
        } else if (error.response.status === 500) {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'Server error. Please try again later.',
          });
          toast.error('Server error. Please try again later.');
        } else {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'An unknown error occurred. Please try again soon.',
          });
          toast.error('An unknown error occurred. Please try again soon.');
        }
      } else if (error.request) {
        dispatch({
          type: CREATE_PASSWORD_FAILURE,
          payload: 'Our server didn’t respond. Please try again in a moment.',
        });
        toast.error('Our server didn’t respond. Please try again in a moment.');
      } else {
        dispatch({
          type: CREATE_PASSWORD_FAILURE,
          payload: 'The request had an error. Please try again later.',
        });
        toast.error('The request had an error. Please try again later.');
      }

      throw error;
    }
  };
};



export const clearresetPasswordError = () => {
  return { type: CLEAR_RESET_PASSWORD_ERROR };
};


export const createPassword = ({ token, password, confirmPassword }, navigate) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_PASSWORD_REQUEST });

    try {
      const response = await api.post(
        '/Accounts/reset-password',
        { token, password, confirmPassword },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
          },
        }
      );

      const userData = response.data;

      // Persist authentication data
      setItem("accessToken", userData.accessToken);
      setItem("isLoggedIn", true);
      setItem("loggedInUserId", userData.id);
      setItem("loggedInUserRoleId", userData.roleId);
      setItem("loggedInUserFirstName", userData.firstName);
      setItem("loggedInUserLastName", userData.lastName);
      setItem("loggedInUserRole", userData.roleName);
      setItem("loggedInUserMembershipId", userData.membershipId);

      localStorage.setItem("userId", userData.id);
      localStorage.setItem("firstName", userData.firstName);
      localStorage.setItem("lastName", userData.lastName);
      localStorage.setItem(
        "loggedInUserRolePermissions",
        JSON.stringify(userData.rolePermissions)
      );

      Cookies.set(
        "loggedInUserRolePermissions",
        JSON.stringify(userData.rolePermissions),
        { expires: 7 }
      );

      dispatch({ type: CREATE_PASSWORD_SUCCESS, payload: userData });

      // Automatically log the user in
      dispatch({ type: LOGIN_SUCCESS, payload: userData });

      toast.success('Password created successfully');
      toast.success('Logging you in...');

      // Navigate to dashboard
      navigate('/dashboard');

      return userData;
    } catch (error) {
      console.error('Create password error:', error);

      if (error.response) {
        if (error.response.status === 400) {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'Invalid request. Please check your password or try again.',
          });
          toast.error('Invalid request. Please check your password or try again.');
        } else if (error.response.status === 401) {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'Invalid or expired token. Please request a new create password link.',
          });
          toast.error('Invalid or expired token. Please request a new create password link.');
        } else if (error.response.status === 403) {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'You do not have permission to create password.',
          });
          toast.error('You do not have permission to create password.');
        } else if (error.response.status === 404) {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'Reset token not found.',
          });
          toast.error('Reset token not found.');
        } else if (error.response.status === 500) {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'Server error. Please try again later.',
          });
          toast.error('Server error. Please try again later.');
        } else {
          dispatch({
            type: CREATE_PASSWORD_FAILURE,
            payload: 'An unknown error occurred. Please try again soon.',
          });
          toast.error('An unknown error occurred. Please try again soon.');
        }
      } else if (error.request) {
        dispatch({
          type: CREATE_PASSWORD_FAILURE,
          payload: 'Our server didn’t respond. Please try again in a moment.',
        });
        toast.error('Our server didn’t respond. Please try again in a moment.');
      } else {
        dispatch({
          type: CREATE_PASSWORD_FAILURE,
          payload: 'The request had an error. Please try again later.',
        });
        toast.error('The request had an error. Please try again later.');
      }

      throw error;
    }
  };
};


export const clearCreatePasswordError = () => {
  return { type: CLEAR_CREATE_PASSWORD_ERROR };
};



export const clearResetPasswordError = () => {
  return { type: CLEAR_RESET_PASSWORD_ERROR };
};
